export default "__VITE_ASSET__D8ELgCes__"